import * as yup from 'yup';

import { FORM_INPUT_ERROR_MSGS } from '../../../../../../../constants/errors';
import {
  appUrlValidation,
  appStatusValidation,
  debugEnabledValidation,
  authorizationMethodValidation
} from '../../../../../../../constants/validation';

const commonValidators = {
  appUrl: appUrlValidation,
  status: appStatusValidation,
  debugEnabled: debugEnabledValidation,
  authorizationMethod: authorizationMethodValidation
};

export const createFormValidations = (appIds: string[]) =>
  yup.object().shape({
    ...commonValidators,
    appId: yup
      .string()
      .trim()
      .required(FORM_INPUT_ERROR_MSGS.REQUIRED('app id'))
      .test('unique', FORM_INPUT_ERROR_MSGS.UNIQUE('app id'), function () {
        return appIds.every(appId => appId !== this.parent.appId);
      })
  });

export const editFormValidations = yup.object().shape(commonValidators);
